// store/modules/planner.js
export default {
    namespaced: true,
    state: {
        staticEvents: {},
        patchEvents: {},
    },
    mutations: {
        clearStaticEvents(state) {
            state.staticEvents = {};
        },

        addNewStaticEvent(state, { eventId, event }) {
            state.staticEvents[eventId] = event;
        },
        removeStaticEvent(state, eventId) {
            if (state.staticEvents[eventId]) {
                delete state.staticEvents[eventId];
            }
        },

        clearPatchEvents(state) {
            state.patchEvents = {};
        },

        addNewPatchEvent(state, { eventId, event }) {
            state.patchEvents[eventId] = event;
        },
        removePatchEvent(state, eventId) {
            if (state.patchEvents[eventId]) {
                delete state.patchEvents[eventId];
            }
        },
    },
    getters: {
        staticEvents(state) {
            return state.staticEvents;
        },
        patchEvents(state) {
            return state.patchEvents;
        },
    },
};
